// 배달 상태 알림
export const deliveryStatusAlarmsConfig = [
  { id: "checkbox1", label: "라이더 콜 접수", alarmName: "callAlarm" },
  { id: "checkbox2", label: "배차 완료", alarmName: "sendAlarm" },
  { id: "checkbox3", label: "조리 시작 (배민1)", alarmName: "cookingAlarm" },
  { id: "checkbox4", label: "조리 시작 (땡배달)", alarmName: "ddangbaedalCookAlarm" }, 
  { id: "checkbox5", label: "라이더 곧도착 (배민1)", alarmName: "startToPickupLocationAlarm" },
  { id: "checkbox6", label: "라이더 곧도착 (땡배달)", alarmName: "ddangbaedalRiderAlarm" }, 
  { id: "checkbox7", label: "라이더 배차지연 (배민1)", alarmName: "unallocatedAlarm" },
  { id: "checkbox8", label: "픽업 완료", alarmName: "pickupAlarm" },
  { id: "checkbox9", label: "배달 완료", alarmName: "deliveryAlarm" },
];

// 주문 채널별 신규 주문 알림
export const channelAlarmsConfig = [
  { type: "channel", image: "BAEMIN", id: "checkbox_BAEMIN", label: "배달의민족 배달", alarmName: "baeminAlarm" },
  {
    type: "channel",
    image: "BAEMIN_PICKUP",
    id: "checkbox_BAEMIN_PICKUP",
    label: "배달의민족 포장",
    alarmName: "baeminPickAlarm",
  },
  {
    type: "channel",
    image: "BAEMIN_SHOP",
    id: "checkbox_BAEMIN_SHOP",
    label: "배달의민족 매장",
    alarmName: "baeminShopAlarm",
  },
  { type: "channel", image: "BAEMINONE", id: "checkbox_BAEMINONE", label: "배민1(배민원)", alarmName: "baemin1Alarm" },
  {
    type: "channel",
    image: "BAEMIN_STORE",
    id: "checkbox_BAEMIN_STORE",
    label: "배민스토어",
    alarmName: "baeminStoreAlarm",
  },
  { type: "channel", image: "YOGIYO", id: "checkbox_YOGIYO", label: "요기요 가게배달", alarmName: "ygyDlvAlarm" },
  { type: "channel", image: "YOGIYO", id: "checkbox_YOGIYOPICK", label: "요기요 포장", alarmName: "ygyPickAlarm" },
  { type: "channel", image: "YOGIYO", id: "checkbox_YOGIYOTABLE", label: "요기요 방문식사", alarmName: "ygyShopAlarm" },
  {
    type: "channel",
    image: "YOGIYOEXPRESS",
    id: "checkbox_YOGIYOEXPRESS",
    label: "요기요 요기배달",
    alarmName: "ygyExpress",
  },
  { type: "channel", image: "DDANGYO", id: "checkbox_DDANGYODLV", label: "땡겨요 배달", alarmName: "ddangyoDlvAlarm" },
  {
    type: "channel",
    image: "DDANGYO",
    id: "checkbox_DDANGYOPICK",
    label: "땡겨요 포장",
    alarmName: "ddangyoPickAlarm",
  },
  {
    type: "channel",
    image: "DDANGYO",
    id: "checkbox_DDANGYOSHOP",
    label: "땡겨요 매장",
    alarmName: "ddangyoShopAlarm",
  },
  {
    type: "channel",
    image: "DDANGBAEDAL",
    id: "checkbox_DDANGBAEDAL",
    label: "땡배달",
    alarmName: "ddangbaedalAlarm",
  },
  {
    type: "channel",
    image: "HASAMDONG_COFFEE",
    id: "checkbox_HASAMDONG_COFFEE",
    label: "하삼동커피",
    alarmName: "hasamdongAlarm",
  },
  { type: "channel", image: "WMPO", id: "checkbox_WMPO", label: "위메프오", alarmName: "wmpoAlarm" },
  { type: "channel", image: "MUKKEBI", id: "checkbox_MUKKEBIDLV", label: "먹깨비 배달", alarmName: "mukkebiDlvAlarm" },
  {
    type: "channel",
    image: "MUKKEBI",
    id: "checkbox_MUKKEBIPICK",
    label: "먹깨비 포장",
    alarmName: "mukkebiPickAlarm",
  },
  { type: "channel", image: "NAVER", id: "checkbox_NAVER", label: "네이버", alarmName: "naverAlarm" },
  { type: "channel", image: "NAVERCONNECT", id: "checkbox_NAVERCONNECT", label: "Npay 커넥트", alarmName: "naverConnectAlarm" },
  { type: "channel", image: "PANDA", id: "checkbox_PANDADLV", label: "헝그리판다 배달", alarmName: "pandaDlvAlarm" },
  {
    type: "channel",
    image: "PANDA",
    id: "checkbox_PANDAPICKUP",
    label: "헝그리판다 포장",
    alarmName: "pandaPickupAlarm",
  },
  {
    type: "channel",
    image: "PANDA",
    id: "checkbox_PANDASELF",
    label: "헝그리판다 판다배송",
    alarmName: "pandaSelfAlarm",
  },
  {
    type: "channel",
    image: "OLTTEA_AH",
    id: "checkbox_OLTTEA_AH",
    label: "올때아아",
    alarmName: "oltteaahAlarm",
  },
  { type: "channel", image: "KIOSK", id: "checkbox_KIOSKPICKUP", label: "키오스크 포장", alarmName: "kioskPickAlarm" },
  { type: "channel", image: "KIOSK", id: "checkbox_KIOSKSHOP", label: "키오스크 매장", alarmName: "kioskShopAlarm" },
  { type: "channel", image: "POS", id: "checkbox_POS", label: "포스", alarmName: "posOrderAlarm" },
  { type: "channel", image: "OKDC", id: "checkbox_TABLE", label: "테이블오더", alarmName: "tableOrderAlarm" },
  { type: "channel", image: "QR", id: "checkbox_QR", label: "QR오더", alarmName: "qrOrderAlarm" },
  { type: "channel", image: "etc", id: "checkbox_etc", label: "기본 알림", alarmName: "newAlarm" },

];
